import { AuthTestimonialPanel } from '@/components/layout/AuthTestimonialPanel'

interface SlimLayoutProps {
  children: React.ReactNode
}

export function SlimLayout({ children }: SlimLayoutProps) {
  return (
    <>
      <div className="relative flex h-screen justify-center md:px-12 lg:px-0">
        <div className="relative z-10 flex flex-1 flex-col bg-white px-4 py-10 shadow-2xl md:flex-none md:justify-center md:px-28">
          <main className="mx-auto w-full max-w-md md:w-96 md:max-w-sm">
            {children}
          </main>
        </div>
        <div className="hidden lg:relative lg:block lg:flex-1">
          <AuthTestimonialPanel />
        </div>
      </div>
    </>
  )
}
